import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-dropdown';

import I18n from 'utils/I18n';

import 'react-dropdown/style.css';
import styles from './styles.scss';

const MIN_YEAR = 1900;

const I18N_MONTHS = (() => {
  const prefix = 'templates.settings.months.';
  return [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec'
  ].map((m) => prefix + m);
})();

const intArray = (min, max) =>
  Array.from({ length: max - min + 1 }, (_, i) => i + min);

const numDaysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();

const DropdownDatePicker = ({
  className,
  dateMax,
  dateSelected,
  dateChangeFn,
  ...otherProps
}) => {
  const changeYear = (year) => {
    const y = year.value;
    const m = dateSelected.getMonth();
    const d =
      dateSelected.getDate() > numDaysInMonth(y, m)
        ? 1
        : dateSelected.getDate();

    const date = new Date(y, m, d);

    dateChangeFn(date > dateMax ? dateMax : date);
  };

  const changeMonth = (month) => {
    const y = dateSelected.getFullYear();
    const m = month.value;
    const d =
      dateSelected.getDate() > numDaysInMonth(y, m)
        ? 1
        : dateSelected.getDate();

    dateChangeFn(new Date(y, m, d));
  };

  const changeDay = (d) => {
    const date = new Date(dateSelected);
    date.setDate(d.value);
    dateChangeFn(date);
  };

  const yearSelected = dateSelected.getFullYear();
  const monthSelected = dateSelected.getMonth();

  const yearMax = dateMax.getFullYear();
  const monthMax = dateMax.getMonth();

  const years = intArray(MIN_YEAR, dateMax.getFullYear()).map((y) => {
    return { label: y, value: y };
  });

  const months = intArray(0, yearSelected === yearMax ? monthMax : 11).map(
    (m) => {
      return { label: I18n.t(I18N_MONTHS[m]), value: m };
    }
  );

  const days = intArray(
    1,
    yearSelected === yearMax && monthSelected === monthMax
      ? dateMax.getDate()
      : numDaysInMonth(yearSelected, monthSelected)
  ).map((d) => {
    return { label: d, value: d };
  });

  return (
    <div className={`${className} ${styles.container}`}>
      {/* month */}
      <Dropdown
        className={styles.month}
        options={months}
        value={months[dateSelected.getMonth()]}
        onChange={changeMonth}
        {...otherProps}
      />

      {/* day */}
      <Dropdown
        className={styles.day}
        options={days}
        value={days[dateSelected.getDate() - 1]}
        onChange={changeDay}
        {...otherProps}
      />

      {/* year */}
      <Dropdown
        className={styles.year}
        options={years}
        value={years[dateSelected.getFullYear() - MIN_YEAR]}
        onChange={changeYear}
        {...otherProps}
      />
    </div>
  );
};

DropdownDatePicker.defaultProps = {
  className: null,
  dateSelected: new Date('1970-1-1'),
  dateMax: new Date(new Date().toDateString()) // today
};

DropdownDatePicker.propTypes = {
  className: PropTypes.string,
  dateSelected: PropTypes.instanceOf(Date),
  dateMax: PropTypes.instanceOf(Date),
  dateChangeFn: PropTypes.func.isRequired
};

export default DropdownDatePicker;
